import { BuildingType } from '@/interfaces/valuation/types/BuildingValuationStep'
import { getNestedValue } from '@/util/helpers'
import { ValidatedResponse } from '@/interfaces/app/ValueObjects'

export const BUILDING_TYPE_MAP: Record<BuildingType, string> = {
  [BuildingType.New]: 'Novostavba',
  [BuildingType.Panel]: 'Panel',
  [BuildingType.Brick]: 'Cihla',
  [BuildingType.Merchant]: 'Historická budova',
}

export function buildingTypeDisplayName(
  buildingType: string
): ValidatedResponse<string> {
  if (Object.values(BuildingType).includes(buildingType as BuildingType)) {
    return {
      valid: true,
      value: BUILDING_TYPE_MAP[buildingType as BuildingType],
    }
  }

  return { valid: false }
}
